import { ComponentRef, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, DetachedRouteHandle } from '@angular/router';
import { Base } from '@sb/library/base';

// The purpose of this class is to keep the old component alive during the route transition animation
@Injectable()
export class TransitionRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldDetach(_: ActivatedRouteSnapshot): boolean {
        return true;
    }

    override store(_: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
        const componentRef = (handle as { componentRef: ComponentRef<any> } | null)?.componentRef;
        if (componentRef) {
            Base.transitionAnimationEnd.subscribe(() => componentRef.destroy());
        }
    }

    override shouldAttach(_: ActivatedRouteSnapshot): boolean {
        return false;
    }

    override retrieve(_: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        return null;
    }
}
